import React from 'react'
import { useTranslation } from 'react-i18next'

function Menu() {
  const { t } = useTranslation()

  const pupusas = [
    'pupusaChicharron', 'pupusaPollo', 'pupusaPastor', 'pupusaFajita',
    'pupusaEspinaca', 'pupusaJalapeno', 'pupusaFrijol', 'pupusaLoroco',
    'pupusaQueso'
  ]
  const tacos = ['tacoPollo', 'tacoFajita', 'tacoPastor']
  const quesadillas = [
    'quesadillaGrandeFajita', 'quesadillaGrandePollo', 'quesadillaGrandePastor',
    'quesadillaChiquitaFajita', 'quesadillaChiquitaPollo', 'quesadillaChiquitaPastor'
  ]
  const burritos = ['burritoFajita', 'burritoPollo', 'burritoPastor']
  const drinks = ['drinkAguaFresca', 'drinkSodaBottle', 'drinkSodaCan', 'drinkWater', 'drinkCoffee']

  const renderItem = (key) => {
    const name = t(`menu.${key}.name`)
    const description = t(`menu.${key}.description`)
    const price = t(`menu.${key}.price`)
    return (
      <li key={key} className="menu-item">
        <div className="menu-item-text">
          <span className="menu-item-name">{name}</span>
          {description && <span className="menu-item-description">{description}</span>}
        </div>
        <span className="menu-item-price">{price}</span>
      </li>
    )
  }

  const renderGroup = ({ sectionKey, noteKey, items, image, alt, openByDefault }) => (
    <details className="menu-group" {...(openByDefault ? { open: true } : {})}>
      <summary className="menu-group-summary">
        <span className="menu-section-heading">{t(`menu.${sectionKey}`)}</span>
        <span className="menu-group-chevron" aria-hidden="true">▾</span>
      </summary>
      <div className="menu-group-body">
        {image && (
          <img
            src={image}
            alt={t(`menu.${alt}`)}
            className="menu-section-image"
            loading="lazy"
            width="800"
            height="600"
          />
        )}
        {noteKey && <p className="menu-section-note">{t(`menu.${noteKey}`)}</p>}
        <ul className="menu-list">{items.map(renderItem)}</ul>
      </div>
    </details>
  )

  return (
    <section id="menu" className="section menu" aria-labelledby="menu-heading">
      <div className="container">
        <h2 id="menu-heading">{t('menu.heading')}</h2>
        <p className="menu-subheading">{t('menu.subheading')}</p>
        <p className="menu-tap-hint">{t('menu.tapToExpand')}</p>

        {/* Pupusas FIRST and OPEN by default — they are the signature. */}
        {renderGroup({
          sectionKey: 'pupusasSection',
          noteKey: 'pupusasNote',
          items: pupusas,
          image: '/images/pupusa-meal.jpg',
          alt: 'pupusaMealAlt',
          openByDefault: true
        })}

        {renderGroup({
          sectionKey: 'tacosSection',
          noteKey: 'tacosNote',
          items: tacos,
          image: '/images/tacos-meal.jpg',
          alt: 'tacosMealAlt'
        })}

        {renderGroup({
          sectionKey: 'quesadillasSection',
          noteKey: 'quesadillasNote',
          items: quesadillas
        })}

        {renderGroup({
          sectionKey: 'burritosSection',
          noteKey: 'burritosNote',
          items: burritos
        })}

        {renderGroup({
          sectionKey: 'drinksSection',
          items: drinks
        })}
      </div>
    </section>
  )
}

export default Menu
